import { useLoginState } from '@xing-com/crate-hooks-use-login-state';

export const useSearchConsumer = (): string => {
  const { isLoggedIn } = useLoginState();

  if (isLoggedIn) {
    return 'loggedin.web.jobs.conv_search_results.center';
  }

  return 'loggedout.web.jobs.conv_search_results.center';
};
